var _rect, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_463",
    "data-name": "Group 463",
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_324",
    "data-name": "Rectangle 324",
    width: 27,
    height: 27,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "speedometer",
    transform: "translate(0.972 4.023)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_437",
    "data-name": "Group 437",
    transform: "translate(0 4.231)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_436",
    "data-name": "Group 436",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4017",
    "data-name": "Path 4017",
    d: "M3.214,146.5A12.642,12.642,0,0,0,0,154.162H3.02a9.639,9.639,0,0,1,2.3-5.552Z",
    transform: "translate(0 -146.502)",
    fill: "#a4a4a4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_439",
    "data-name": "Group 439",
    transform: "translate(11.978 11.711)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_438",
    "data-name": "Group 438",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4018",
    "data-name": "Path 4018",
    d: "M241.413,298.751h0a.745.745,0,0,0-.413.668.772.772,0,0,0,1.3.5L244.907,297Z",
    transform: "translate(-241 -297.002)",
    fill: "#a4a4a4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_441",
    "data-name": "Group 441",
    transform: "translate(4.268)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_440",
    "data-name": "Group 440",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4019",
    "data-name": "Path 4019",
    d: "M85.882,64.556l2.108,2.108a9.786,9.786,0,0,1,5.6-2.3V61.38A12.741,12.741,0,0,0,85.882,64.556Z",
    transform: "translate(-85.882 -61.38)",
    fill: "#a4a4a4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_443",
    "data-name": "Group 443",
    transform: "translate(13.469)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_442",
    "data-name": "Group 442",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4020",
    "data-name": "Path 4020",
    d: "M271,61.38v2.982a9.786,9.786,0,0,1,5.6,2.3l2.108-2.108A12.741,12.741,0,0,0,271,61.38Z",
    transform: "translate(-271 -61.38)",
    fill: "#a4a4a4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_445",
    "data-name": "Group 445",
    transform: "translate(20.125 4.231)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_444",
    "data-name": "Group 444",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4021",
    "data-name": "Path 4021",
    d: "M407.028,146.5l-2.108,2.108a9.639,9.639,0,0,1,2.3,5.552h3.02A12.642,12.642,0,0,0,407.028,146.5Z",
    transform: "translate(-404.92 -146.502)",
    fill: "#a4a4a4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_447",
    "data-name": "Group 447",
    transform: "translate(0 4.435)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_446",
    "data-name": "Group 446"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4022",
    "data-name": "Path 4022",
    d: "M22.4,159.566a9.659,9.659,0,0,1-.489,2.484.746.746,0,1,1-1.407-.5,8.2,8.2,0,0,0-1.937-8.53h0a8.308,8.308,0,0,0-11.691,0h0a8.2,8.2,0,0,0-1.937,8.53.746.746,0,0,1-1.407.5,9.661,9.661,0,0,1-.489-2.484H0a12.394,12.394,0,0,0,1.248,4.745,2.211,2.211,0,0,0,2,1.219H22.2a2.213,2.213,0,0,0,2-1.22,12.759,12.759,0,0,0,1.247-4.744H22.4Zm-2.75-3.589L14.391,161.8a2.237,2.237,0,1,1-2.669-3.49l0,0,7.039-3.5.007,0A.745.745,0,0,1,19.652,155.977Z",
    transform: "translate(0 -150.62)",
    fill: "#a4a4a4"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboard-icon.2b47f3175d6c7a538ea8be5a2041fdff.svg";
export { ForwardRef as ReactComponent };